import "./index.scss";
import { LINK_LIST } from "./utils/linkList";

export const PortalFooterLink = () => {
  return (
    <nav className="portal-footer-link">
      <ul className="link-desktop">
        {LINK_LIST.desktop.map(({ label, url }) => (
          <li key={label}>
            <a
              href={url}
              rel="noopener noreferrer"
              target="_blank"
              aria-label={label}
            >
              {label}
            </a>
          </li>
        ))}
      </ul>
      <ul className="link-default">
        {LINK_LIST.default.map(({ label, url }) => (
          <li key={label}>
            <a
              href={url}
              rel="noopener noreferrer"
              target="_blank"
              aria-label={label}
            >
              {label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};
